import type { RefObject } from 'react'
import { createContext, useContext } from 'react'
import type { BehaviorSubject } from 'rxjs'

export type NavigationSource = 'mouse' | 'keyboard' | 'select'

export type NavigationListState = {
  selectedId$: BehaviorSubject<{
    id: string
    source: NavigationSource
  } | null>
  focusItems: boolean
  direction: 'vertical' | 'horizontal'
  getSelectedId(): string | null
  next: (source?: NavigationSource) => void
  previous: (source?: NavigationSource) => void
  deselect: () => void
  select: (id: string, source?: NavigationSource) => void
  selectFirst: (source?: NavigationSource) => void
  scrollBoundaryRef: RefObject<HTMLDivElement | null>
}

const navigationListContext = createContext<NavigationListState | null>(null)

export function useNavigationListContext() {
  const context = useContext(navigationListContext)

  if (!context) {
    throw new Error(
      'useNavigationListContext must be used within a NavigationList'
    )
  }

  return context
}

export const NavigationListProvider = navigationListContext.Provider
